MxInjectorService.$inject = ['$q', '$http', '$controller', '$injector', '$templateCache'];

/**
 * @ngdoc service
 * @kind function
 * @name mx.shell.InjectorService
 * @module mx.shell
 *
 * @description
 * A service provides methods for loading controllers and views
 * */
export function MxInjectorService($q, $http, $controller, $injector, $templateCache) {
	return {
		controller: controller,
		view: view,
	};

	/**
	 * @ngdoc method
	 * @name mx.shell.InjectorService#controller
	 *
	 * @description
	 * Returns a promise that resolves controller
	 *
	 * @param {object} definition - a container for controller definition
	 */
	function controller(definition) {
		var defer = $q.defer();

		if (definition.controller) {
			if (typeof definition.controller === 'string' || typeof definition.controller === 'function') {
				var ctrl;

				try {
					ctrl = $controller(definition.controller);
				} catch (exception) {
					throw new Error('Cannot instantiate controller. exception: ' + exception + '. controller definition: ' + definition.controller);
				}
				defer.resolve(ctrl);
			} else {
				throw new Error('Cannot instantiate controller. Incorrect controller provided. Expected string or function');
			}
		} else if (definition.controllerUrl) {
			__non_webpack_require__([definition.controllerUrl], function (res) {
				defer.resolve($injector.invoke(res));
			});
		} else {
			defer.resolve(null);
		}
		return defer.promise;
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.InjectorService#view
	 *
	 * @description
	 * Returns a promise that resolves view markup
	 *
	 * @param {string} url - a container for controller definition
	 */
	function view(url) {
		var defer = $q.defer();

		$http.get(url, { cache: $templateCache }).then(
			function (response) {
				defer.resolve(response.data);
			},
			function () {
				throw new Error('Cannot load ' + url);
			}
		);

		return defer.promise;
	}
}
